module.exports = __webpack_public_path__ + "static/media/search.edf93eae.svg";